// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5273ee9f","455":"7c7c2111","977":"e6c5d5a4"}[chunkId] + ".chunk.js";
};